import * as React from 'react';
import Tabs from './Tabs';
import TabLink from './TabLink';
import { BaseProps } from '../icons';
import { Size } from '../types';

export interface VerticalTabEntry {
  requiredLine: string;
  optionalLine?: string;
  optionalLineIcon?: React.ReactNode;
  endLineIcon?: React.ReactNode;
  to: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  showNotificationDot?: boolean;
  variant?: 'critical' | 'positive';
}
interface VerticalTabsProps {
  size?: Size.Small | Size.Medium | Size.Large;
  entries: VerticalTabEntry[];
}

const VerticalTabs = ({ size, entries }: VerticalTabsProps) => {
  return (
    <Tabs size={size ?? Size.Large}>
      {entries?.map((entry: VerticalTabEntry) => (
        <TabLink
          key={entry.to}
          to={entry.to}
          requiredLine={entry.requiredLine}
          optionalLine={entry.optionalLine}
          endLineIcon={entry.endLineIcon}
          OptionalLineIcon={entry.optionalLineIcon}
          disabled={entry.disabled}
          showNotificationDot={entry.showNotificationDot}
          size={size}
          variant={entry.variant}
          onLinkClick={(e) => {
            if (entry.onClick) {
              entry.onClick(e);
            }
          }}/>
      ))}
    </Tabs>
  );
};

export default VerticalTabs;
